import { faImage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";

function ModalHeader(props:any) {
  const { title, useIcon, icon } = props;
  return (
    <Modal.Header closeButton>
      <Modal.Title>
        {
          useIcon && 
          <div style={{ display: "inline-block" }}>
            {
              (useIcon && icon) ? 
                (<img src={icon} alt="icon for product" />)
              : 
                (
                  <div className="no-image" title="No product icon available.">                
                    <FontAwesomeIcon icon={faImage} fixedWidth />
                  </div>
                )
            }
          </div> 
        }
        <span style={{ margin: "0 5px" }}>{title}</span>
      </Modal.Title>
    </Modal.Header>
  );
}

export default ModalHeader;